<template>
  <div class="cep-user-message">
    <div class="cep-user-message-body">
      <div class="cep-user-bubble">{{ text }}</div>
      <div v-if="isDebugMode" class="cep-debug-bar">
        <span class="cep-debug-time">{{ formattedTime }}</span>
        <button class="cep-debug-copy" :class="{ copied: copySuccess }" :title="copySuccess ? 'Copied' : 'Copy'" @click="copyMessage">
          <svg v-if="!copySuccess" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1"/></svg>
          <svg v-else xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>
        </button>
      </div>
    </div>
    <div class="cep-user-avatar">{{ initials }}</div>
  </div>
</template>

<script>
const IS_DEBUG = process.env.BUILD_TYPE === 'dev'

export default {
  name: 'UserMessage',
  props: {
    text: {
      type: String,
      default: ''
    },
    initials: {
      type: String,
      default: 'U'
    },
    timestamp: {
      type: Number,
      default: null
    }
  },
  data () {
    return { copySuccess: false }
  },
  computed: {
    isDebugMode () {
      return IS_DEBUG
    },
    formattedTime () {
      if (!this.timestamp) return ''
      return new Date(this.timestamp).toLocaleTimeString(undefined, {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        fractionalSecondDigits: 3
      })
    }
  },
  methods: {
    copyMessage () {
      navigator.clipboard.writeText(this.text).then(() => {
        this.copySuccess = true
        setTimeout(() => { this.copySuccess = false }, 2000)
      })
    }
  }
}
</script>

<style scoped>
.cep-user-message {
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  gap: 10px;
  margin-bottom: 16px;
}

.cep-user-message-body {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 4px;
  max-width: 50%;
}

.cep-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #e91e8c;
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.cep-user-bubble {
  background: #E6F5F4;
  border-radius: 12px 0 12px 12px;
  padding: 12px 16px;
  font-size: 14px;
  color: #1a1a2e;
  line-height: 1.5;
  width: 100%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.cep-debug-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 4px;
}

.cep-debug-time {
  font-size: 11px;
  color: #888;
  font-family: monospace;
}

.cep-debug-copy {
  font-size: 11px;
  color: #0D9488;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  font-weight: 500;
}

.cep-debug-copy.copied {
  color: #4caf50;
}
</style>



// WEBPACK FOOTER //
// UserMessage.vue?206f0215